<template>
  <div class="flex w-full">    
    <div class="w-1/4 mr-2">
      <b>File</b><br>
      <l-input placeholder="Click icon to select csv file" inputClass="text-2xs" :disabled="true" :value="file.name" >
        <template slot="prefix">
          <l-upload icon="file-csv" accept=".csv" class="text-xl text-pastel-green-500" @on-click="onFileSelect"/>
        </template>
      </l-input>
    </div>
    <div class="w-1/4">
      <b></b><br>      
      <l-button type="success" :disabled="!file.name" @click="onImport">Import csv file</l-button>
    </div>
  </div>
</template>

<script>
import { LInput, LButton, LUpload } from "@/components/forms";
export default {
  name: "LCsvImport",
  components: {
    LInput,
    LButton,
    LUpload
  },
  data() {
    return {
      file: {}
    };
  },
  methods: {
    onFileSelect(file) {
      this.file = file;
    },
    onImport() {
      this.$emit("on-import", this.file);
      this.file = {};
    }
  }
};
</script>